module.exports = __webpack_public_path__ + "static/img/oil3.1883b968.png";